module.exports = __webpack_public_path__ + "static/media/20170617-202519-022.70c6529e.png";